"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_COMPANY_REGIONS_SIMPLE = void 0;
var client_1 = require("@apollo/client");
exports.GET_COMPANY_REGIONS_SIMPLE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetCompanyRegionsSimple($companyId: ID!) {\n    companyRegions(companyId: $companyId) {\n      id\n      name\n      parentId\n    }\n  }\n"], ["\n  query GetCompanyRegionsSimple($companyId: ID!) {\n    companyRegions(companyId: $companyId) {\n      id\n      name\n      parentId\n    }\n  }\n"])));
var templateObject_1;
